import { Box, ProgressBar, Text } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectRegistrationConfig,
  selectRegistrationProgress,
} from '../../../../state';

function ProgressSection() {
  const config = useSelector(selectRegistrationConfig);
  const progress = useSelector(selectRegistrationProgress);
  return (
    <Box flexDirection="row" alignItems="center" gap="space-050">
      <Box flexDirection="row" alignItems="center">
        <Text
          variant="body-s"
          color="darkSurfaceSecondary"
        >{`${progress}% `}</Text>
        <Text
          variant="body-s"
          locNS="registration"
          locKey="complete"
          color="darkSurfaceSecondary"
        ></Text>
      </Box>
      <Box width={80}>
        <ProgressBar
          from={config.startPercentage || 0}
          to={config.endPercentage || 100}
          progress={progress}
          backgroundColor="mutedBackground"
        />
      </Box>
    </Box>
  );
}

export default ProgressSection;
